/** Here is the typical component from react being rendered for the corresponding form*/
import React from "react";
import EntityForm from "../EntityForm/EntityForm";
import "./customStyles.css";
import NestedQuestionnairesList from "./NestedQuestionnaires/NestedQuestionnairesList";
import NestedQuestionnairesForm from "./NestedQuestionnaires/NestedQuestionnairesForm";
import { entityToFormValuesMapper } from "../../Common/utils";
import CONSTANTS from "../constants";
import asBookingEngineEntity from "../Common/BookingEngineEntityHOC";
import { withPropertyData } from "../../../../components/property-admin-data-provider";

/** this function is called when the JSON will be written at the corresponding field*/
function customEntityToFormValuesMapper({ entity, fields, locales, translationConfig }) {
  const formValues = entityToFormValuesMapper({
    entity,
    fields,
    locales,
    translationConfig,
  });

  /** Here we transform the required into a boolean*/
  formValues.fields.forEach(value => {
    value.required =
      (value.constraints.presence && !value.constraints.presence.allowEmpty) || false;
  });

  /** here the "enable for:" and the corresponding checkboxes are created*/
  if (Array.isArray(formValues.dependers)) {
    formValues.dependersBoxes =
      formValues.dependers[0].tickers && formValues.dependers[0].tickers.split(",");
    formValues.dependers = formValues.dependers[0].type;
  }

  /** Here we get every item level from every translation from every field and transform it to string so it matches the value expected by the input*/
  formValues.fields &&
    formValues.fields.forEach(field => {
      field.translations &&
        field.translations.forEach(translation => {
          let itemsLabel = [];
          translation.items &&
            translation.items.forEach(item => {
              itemsLabel.push(item.label);
            });
          translation.items = itemsLabel.join();
        });
    });
  return { ...formValues };
}

class QuestionnairesForm extends React.Component {
  static nestedFomWidgets = {
    /** here is where the nested entity links with the fieldName declared at the module definition, also the corresponding form and list must be imported*/
    fields: asBookingEngineEntity(NestedQuestionnairesForm, {
      entityName: CONSTANTS.ENTITY.NESTEDQUESTIONNAIRE.name,
      type: "FORM",
    }),
  };

  static nestedListWidgets = {
    fields: asBookingEngineEntity(NestedQuestionnairesList, {
      entityName: CONSTANTS.ENTITY.NESTEDQUESTIONNAIRE.name,
      type: "LIST",
    }),
  };

  getFields({ fields, availableExtras }) {
    if (!fields || !fields.form) {
      return undefined;
    }
    return fields.form.map(it =>
      it.fieldName === "dependersBoxes"
        ? {
            ...it,
            options: availableExtras,
          }
        : it
    );
  }
  /** this function is called when the fields will be written and returned to the API*/
  handleSubmit = ({ formValues }) => {
    //TODO: handle case when there's an original entity
    //TODO: this could be handled in a generic way.
    const { id, ...otherFormValues } = formValues;
    const entity = {
      ...otherFormValues,
    };

    if (id !== "" && id !== " " && id !== null && typeof formValues.id !== "undefined") {
      entity.id = formValues.id;
    }

    /** Here we return the constraint value back to being and object*/
    entity.fields.forEach(value => {
      if (typeof value.required !== "object") {
        value.required === false
          ? (value.constraints = {})
          : (value.constraints = { presence: { allowEmpty: !value.required } });
      }
      delete value.required;
    });
    /** It returns the dependers to be an object and join the multicheckbox values into the corresponding fields*/
    if (typeof entity.dependers !== "object") {
      entity.dependers = [
        {
          type: entity.dependers,
          tickers: entity.dependersBoxes && entity.dependersBoxes.join(),
        },
      ];
      delete entity.dependersBoxes;
    }

    /** Here the translations items are recomberted to an Array ov objects*/
    entity.fields &&
      entity.fields.forEach(field => {
        field.widgetType === "STAY_DATE"
          ? field.translations &&
            field.translations.forEach(translation => {
              delete translation.items;
            })
          : field.translations &&
            field.translations.forEach(translation => {
              if (typeof translation.items === "string") {
                const itemsArr = translation.items.split(",");
                translation.items = [];
                itemsArr.forEach(value => {
                  translation.items.push({ label: value, value: value });
                });
              }
            });
      });

    this.props.onSubmitEntity({
      entity,
    });
  };

  render() {
    const { name, validation, fields, renderers, translation, entities } = this.props.config;
    const {
      locales,
      entity,
      entityError,
      entityResult,
      loading,
      getListPath,
      ...otherProps
    } = this.props;
    const { getFields, handleSubmit } = this;
    return (
      <div className={"wbkv9-form-questionnaire"}>
        <EntityForm
          loading={loading}
          name={name}
          entity={entity}
          entities={entities}
          validation={validation}
          renderers={renderers}
          fields={getFields({ fields, availableExtras: this.props.wbkData.extras || [] })}
          locales={locales}
          translation={translation}
          onSubmit={handleSubmit}
          entityError={entityError}
          entityResult={entityResult}
          getListPath={getListPath}
          nestedFormWidgets={QuestionnairesForm.nestedFomWidgets}
          nestedListWidgets={QuestionnairesForm.nestedListWidgets}
          entityToFormValuesMapper={customEntityToFormValuesMapper}
          {...otherProps}
        />
      </div>
    );
  }
}

QuestionnairesForm.propTypes = {};

QuestionnairesForm.defaultProps = {
  locales: ["es", "ca", "en", "fr", "it", "de"],
};

export default withPropertyData(QuestionnairesForm);
